import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '../../../../service/axios';
import { toast } from 'react-toastify';
import queryString from 'query-string';

//get All expense Forms
export const getMachineryType = createAsyncThunk('machineryTypeSlice/getMachineryType', async () => {
    try {
        let response = await axios.get('/machinery-type', {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        return Promise.reject(err);
    }
});

//Get Expense Form by Id
export const getMachineryTypeById = createAsyncThunk('machineryTypeSlice/getMachineryById', async (id) => {
    try {
        let response = await axios.get(`/machinery-type/${id}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);

        return Promise.reject(err);
    }
});

//Get Expense Form Category Options
export const getMachineryTypeOptions = createAsyncThunk('machineryTypeSlice/getMachineryOptions', async (params) => {
    try {
        const query = params ? queryString.stringify(params) : '';
        let response = await axios.get(`/machinery-type/options${query ? `?${query}` : ''}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });

        return Promise.resolve(response.data.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});

//Create Machinery
export const createMachineryType = createAsyncThunk('machineryTypeSlice/createMachinery', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.post(`/machinery-type`, data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Machinery added successfully.');
        dispatch(getMachineryType());

        return Promise.resolve(response.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});

//Edit Machinery
export const updateMachineryType = createAsyncThunk('machineryTypeSlice/updateMachinery', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.put('/machinery-type/' + data.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Machinery updated successfully.');
        dispatch(getMachineryType());

        return Promise.resolve(response.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});


//Edit Machinery Type Status
export const updateMachineryTypeStatus = createAsyncThunk('machineryTypeSlice/updateMachineryTypeStatus', async (id, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.put('/machinery-type/status/' + id, {
            loader: false
        });
        toast.success(response?.data?.message || 'Machinery updated successfully.');
        dispatch(getMachineryType());

        return Promise.resolve(response.data);
    } catch (err) {
        if (!err.response?.data.fields || err.response?.data?.fields?.length == 0) {
            toast.error(err?.response?.data?.message || 'Something went wrong!');
        }
        console.log('err', err);
        return rejectWithValue(err);
    }
});


export const deleteMachineryType = createAsyncThunk('machineryTypeSlice/deleteMachineryType', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/machinery-type/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Machinery Type deleted successfully.');
        await dispatch(getMachineryType());

        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const machineryTypeSlice = createSlice({
    name: 'machineryTypeSlice',
    initialState: {
        data: [],
        selectedMachineryType: {},
        machineryOptions: {}
    },
    extraReducers: (builder) => {
        builder.addCase(getMachineryType.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
        builder.addCase(getMachineryTypeById.fulfilled, (state, action) => {
            state.selectedMachineryType = action?.payload;
            return;
        });
        builder.addCase(getMachineryTypeOptions.fulfilled, (state, action) => {
            state.machineryOptions = action?.payload;
            return;
        });
    }
});

export default machineryTypeSlice.reducer;
